import { Button, mergeClasses } from "@fluentui/react-components";
import React, { useCallback } from "react";
import { buttonStyles } from "../../../styles/buttonStyles";
import { mapControlsStyles } from "../map-displays/mapStyles";

interface IAirportView {
  label: string;
  zoom: number;
  title: string;
}

const AIRPORT_VIEWS: IAirportView[] = [
  { label: "Runway View", zoom: 14, title: "Runway View" },
  { label: "10 miles", zoom: 13, title: "10 Mile View" },
  { label: "50 miles", zoom: 11, title: "50 Mile View" },
];

interface IAirportViewControls {
  onViewChange: (zoom: number) => void;
}

const AirportViewControls: React.FC<IAirportViewControls> = ({
  onViewChange,
}) => {
  const viewControlsStyles = mapControlsStyles();
  const buttonStyleClasses = buttonStyles();

  const handleViewChange = useCallback(
    (zoom: number) => () => {
      onViewChange(zoom);
    },
    [onViewChange]
  );

  return (
    <div
      className={mergeClasses(
        viewControlsStyles.cardContainer,
        viewControlsStyles.viewControls
      )}
    >
      <span className={viewControlsStyles.viewControlsLabel}>
        Airport Views
      </span>
      {AIRPORT_VIEWS.map(({ label, zoom }) => (
        <Button
          key={zoom}
          className={mergeClasses(
            buttonStyleClasses.applyButton,
            viewControlsStyles.viewButton
          )}
          size="small"
          onClick={handleViewChange(zoom)}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};

export default AirportViewControls;
